import { z } from "zod";

import {
	PriceRankItemInputSchema,
	PriceRankRoomItemInputSchema,
	RoomPriceObjectInputSchema,
	RoomPriceRankMastInputSchema,
} from "@/lib/zod/__generated__/validation-schema";

import {
	hexColorZodSchema,
	priceObjectZodSchema,
} from "@/components/features/_shared/validation-schema/validation-schema";

export const roomPriceRankMastInputZodSchema = RoomPriceRankMastInputSchema.extend({
	ranks: z.array(
		z.lazy(() =>
			PriceRankItemInputSchema.extend({
				name: z.string().min(1).max(50), //
				isStopSelling: z.boolean(),
				color: hexColorZodSchema,
				rooms: z
					.array(
						z.lazy(() =>
							PriceRankRoomItemInputSchema.extend({
								prices: z
									.array(
										z.lazy(() =>
											RoomPriceObjectInputSchema.extend({
												price: priceObjectZodSchema,
											}),
										),
									)
									.nullish(), //
							}),
						),
					)
					.nullish(),
			}),
		),
	),
});

export type RoomPriceRankMastInputZodSchemaType = z.infer<typeof roomPriceRankMastInputZodSchema>;
